import { useLang } from "@/i18n/LanguageContext";

const ITEMS_EN = [
  "Product understanding",
  "Market intelligence",
  "Channel mapping",
  "Company discovery",
  "Opportunity evaluation",
  "International B2B",
];

const ITEMS_TR = [
  "Ürün anlayışı",
  "Pazar istihbaratı",
  "Kanal haritalama",
  "Şirket keşfi",
  "Fırsat değerlendirme",
  "Uluslararası B2B",
];

export default function Marquee() {
  const { lang, tx } = useLang();
  const items = lang === "tr" ? ITEMS_TR : ITEMS_EN;
  const row = [...items, ...items];
  return (
    <section
      aria-label={tx("Capabilities", "Yetkinlikler")}
      className="overflow-hidden border-y border-slate-200 bg-white py-5"
    >
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center" aria-hidden={i >= items.length}>
            <span className="px-8 font-display text-sm font-medium uppercase tracking-[0.28em] text-slate-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 bg-gold/70" aria-hidden="true" />
          </span>
        ))}
      </div>
    </section>
  );
}
